<template lang="html">
    <div id="nav">
      <div class="container">
          <router-link class="logo" to="/">
              <img src="https://static.qyjmed.com/webSite/index/logo-index.png" alt="">
          </router-link>
          <div class="nav-bar">
              <router-link  to="/" exact>首页</router-link>
              <span @mouseover="navServer=true" @mouseleave='navServer=false'>产品服务</span>
              <router-link to="/document">文档资料</router-link>
              <router-link to="/news">新闻资讯</router-link>
              <span @mouseover="navAbout=true" @mouseleave='navAbout=false'>关于我们</span>
              <span @mouseover="navContent=true" @mouseleave='navContent=false'>联系我们</span>
              <span>
                  <img src="https://static.qyjmed.com/webSite/index/dianhua.png" alt="">400-058-0200
              </span>
              <button v-if="!isLogin" @click="login()" type="button" name="button">登录</button>
              <span v-else @mouseover="exit=true" @mouseleave='exit=false' class="over-hidden"><marquee scrollamount="5">{{name}}</marquee></span>
              <!-- <button @mouseover="ewm=true" @mouseleave='ewm=false' type="button" name="button">登陆</button> -->
              <!-- <div v-show='ewm' class="ewm">
                  <img src="https://static.qyjmed.com/webSite/index/wx.png" alt="">
              </div> -->
          </div>
      </div>
      <div v-show="navServer" class="nav-server">
          <div @mouseover="navServer=true" @mouseleave='navServer=false' class="container">
              <router-link to="/software">设备管理软件</router-link>
              <router-link to="/app">全医佳app</router-link>
              <router-link to="/service">全医佳客服系统</router-link>
              <router-link to="/cloud">云服务平台</router-link>
              <router-link to="/maintenance">维保服务</router-link>
              <!-- <router-link to="/supply">供应链金融</router-link> -->
          </div>
      </div>
      <div v-show="navAbout" class="nav-about">
          <div @mouseover="navAbout=true" @mouseleave='navAbout=false' class="container">
              <router-link to="/qyj">全医佳</router-link>
              <router-link to="/ja">极安</router-link>
              <router-link to="/cna">彩超联盟</router-link>
              <router-link to="/adv">我们的优势</router-link>
          </div>
      </div>
      <div v-show="navContent" class="nav-content">
          <div @mouseover="navContent=true" @mouseleave='navContent=false' class="container">
              <router-link to="/join">招聘</router-link>
              <router-link to="/repairs">报修</router-link>
              <router-link to="/teamwork">业务合作</router-link>
          </div>
      </div>
      <div v-show="exit" class="nav-exit">
          <div @mouseover="exit=true" @mouseleave='exit=false' class="container">
              <ul>
                  <li @click="exitLogin()"><img src="https://static.qyjmed.com/webSite/index/exit.png" alt="">退出</li>
              </ul>
          </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
	name: 'HeaderTop',
	data() {
		return {
			navServer: false,
			navAbout: false,
			navContent: false,
			ewm: false,
			isLogin: false,
			name: '',
			exit: false,
		}
	},
	methods: {
		login() {
			this.$router.push({
				path: './login'
			})
		},
		getData: function() {
			let redirect = decodeURIComponent(this.$route.query.redirect || "/")
			console.log(redirect)
			axios.post('/api/oAuth/getUserInfo').then((res) => {
				if (res.data.code == 1) {
					this.isLogin = true
					this.name = res.data.data.hosName
					this.$nextTick(function() {
						this.$store.commit('getLogin', this.name)
						sessionStorage.setItem('token', '111')
					})
				} else {

				}
			}).catch(function(err) {
				console.log(err)
			})
		},
		exitLogin: function() {
			axios.post('/api/oAuth/logOut').then((res) => {
				if (res.data.code == 1) {
					this.isLogin = false
					this.name = ''
					this.$nextTick(function() {
						this.$store.commit('getLogin', this.name)
						sessionStorage.setItem('token', this.name)
					})
				} else {

				}

			}).catch(function(err) {
				console.log(err)
			})
		}
	},
	computed: {
		listenName() {
			return this.$store.state.login;
		}
	},
	// created(){
	//   console.log(this.$store.state.login);
	// },
	watch: {
		listenName: function(newV, oldV) {
			if (newV != '') {
				this.isLogin = true
				this.getData()
			}
		}
	},
	created() {
		this.getData()
	}
}
</script>

<style lang="scss" scoped>
#nav {
    position: relative;
    height: 100px;
    line-height: 100px;
    z-index: 100;
    background-color: #0c062930;
    border-bottom: 1px solid #ffffff34;
    .container {
        height: 100px;
        .logo {
            width: 30%;
            display: inline-block;
            vertical-align: top;
            height: 70px;
            img {
                // padding-top: 20px;
            }
        }
        .nav-bar {
            width: 70%;
            text-align: right;
            display: inline-block;
            font-size: 14px;
            position: relative;
            overflow: hidden;
            /*超出部分隐藏*/
            white-space: nowrap;
            button {
                padding: 10px 24px;
                background-color: transparent;
                color: #3D81E5;
                border: 2px solid #3D81E5;
                margin-left: 30px;
                cursor: pointer;
            }
            .ewm {
                position: absolute;
                right: -40px;
            }
            a {
                padding: 40px 20px;
                border-bottom: 2px solid transparent;
                img {
                    vertical-align: middle;
                    padding-right: 4px;
                    margin-bottom: 2px;
                }
                &:hover:not(:nth-last-child(2)) {
                    color: #49A9FD;
                    border-bottom: 2px solid #49A9FD;
                }
            }
            span {
                color: white;
                padding: 40px 20px;
                border-bottom: 2px solid transparent;
                img {
                    vertical-align: middle;
                    padding-right: 4px;
                    margin-bottom: 2px;
                }
                &:hover:not(:nth-last-child(2):nth-last-child(1)) {
                    color: #49A9FD;
                    border-bottom: 2px solid #49A9FD;
                    cursor: pointer;
                }
                &:last-child {
                    color: #60b3ec;
                    white-space: unset;
                    marquee {
                        width: 100px;
                        height: 41px;
                    }
                }
            }
        }
        a {
            color: white;
        }
        @include w-1200;
    }
    // 鼠标悬停的效果
    .nav-about,
    .nav-content,
    .nav-server {
        font-size: 14px;
        background: #0c062930;
        text-align: right;
        a {
            padding: 24px 20px;
            &:hover {
                color: #49A9FD;
            }
        }
    }
    .nav-server a:last-child {
        // margin-right: 129px;
        margin-right: 200px;
    }
    .nav-about a:last-child {
        margin-right: 200px;
    }
    .nav-content a:last-child {
        margin-right: 180px;
    }
    // 退出
    .nav-exit {
        .container {
            ul {
                line-height: 50px;
                li {
                    text-align: right;
                    color: white;
                    cursor: pointer;
                    padding-right: 40px;
                    font-size: 12px;
                    img {
                        height: 12px;
                        margin-right: 6px;
                    }
                }
            }
        }
    }
}
</style>
